import { inject, injectable } from 'inversify'
import { RequestHandler, requestHandler } from 'mediatr-ts'

import { SessionManager } from '@infrastructure/managers/session/session-manager'

import { SignInCommand } from './command'

@requestHandler(SignInCommand)
@injectable()
export class SignInCommandHandler implements RequestHandler<SignInCommand, void> {
  constructor(@inject(SessionManager) private readonly sessionManager: SessionManager) {}

  public async handle({ email, password }: SignInCommand): Promise<void> {
    await this.sessionManager.signIn(email, password)
  }
}
